import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getActiveFilters } from 'selectors/search';
import { Filter } from '../helpers';
import FilterGroup from './FilterGroup';
import { contactsKeys } from './keys';

const Contacts = ({ loading }) => {
  const activeFilters = useSelector(
    getActiveFilters(Object.keys(contactsKeys))
  );

  return (
    <FilterGroup
      icon='user'
      title='Contacts'
      activeKeys={activeFilters}
      sectionKey='contacts'
    >
      <>
        <Filter
          filterType='token'
          placeholder='Full Name'
          filterId={contactsKeys.fullName.key}
          disabled={loading}
          includeExclude
        />
        <Filter
          filterType='token'
          placeholder='Last Name'
          filterId={contactsKeys.lastName.key}
          disabled={loading}
          includeExclude
        />
        <Filter
          filterType='token'
          placeholder='Job title'
          filterId={contactsKeys.jobTitle.key}
          disabled={loading}
          includeExclude
        />
        <Filter
          filterType='checkbox'
          filterId={contactsKeys.recentlyMovedOrg.key}
          disabled={loading}
          labelText='Moved organisation within last six months'
        />
      </>
    </FilterGroup>
  );
};

Contacts.propTypes = {
  loading: PropTypes.bool,
};

export default Contacts;
